(function () {
    // Load check
    if (!jQuery) {
        console.log('NOT LOADED!');
        return;
    }
    
    (function ($) {
        window.OferaCRM = window.OferaCRM || {};
        OferaCRM.FE = OferaCRM.FE || {};
        
        OferaCRM.FE.Index = {
            elements: {
                $search: $('.js-start-search'),
                $cityId: $('.js-city-id'),
                $citySeo: $('.js-city-seo'),
                $countyId: $('.js-county-id'),
                $countySeo: $('.js-county-seo'),
                $term: $('.js-term')
            },
            
            doSearch: function () {
                var self = OferaCRM.FE.Index;
                var E = self.elements;

                console.log('Starting search...');

                var url = '';

                if (E.$countySeo.length && E.$countySeo.val()) {
                    url += '/judet-' + E.$countySeo.val();
                } else {
                    if (E.$citySeo.length && E.$citySeo.val()) {
                        url += '/' + E.$citySeo.val();
                    }
                }

                if (E.$term.val()) {
                    url += '/cautare-' + E.$term.val().replace(/ /g, '-');
                }

                if (url) {
                    location.href = window.BASE_URL + url;
                } else {
                    location.href = window.BASE_URL + '/cauta';
                }
            }
        };

        $("#searchmodel-auto").on('keyup', function () {
            var self = OferaCRM.FE.Index;
            var E = self.elements;
            
            var $this = $(this);
            var $locationAutosuggest = $('.e-location-autosuggest');
            
            if ($this.val().length < 3) {
                E.$cityId.val('');
                E.$citySeo.val('');
                E.$countyId.val('');
                E.$countySeo.val('');
                $locationAutosuggest.html('');
                return;
            }
            var searchTerm = $this.val().toUpperCase();
            searchTerm = searchTerm.replace(/Ă/g, 'A'); 
            searchTerm = searchTerm.replace(/Â/g, 'A'); 
            searchTerm = searchTerm.replace(/Î/g, 'I'); 
            searchTerm = searchTerm.replace(/Ș/g, 'S'); 
            searchTerm = searchTerm.replace(/Ț/g, 'T');
            
            var results = [];
            
            OferaCRM.localeData.forEach(function (county) {
                if (county.searchName.indexOf(searchTerm) === 0) {
                    results.push({
                        id: county.id,
                        name: county.name,
                        seokey: county.name.toLowerCase(),
                        isCounty: 1,
                        displayName: '<span class="e-location-name">Toate din județul ' + county.name + '</span>'
                    });
                }
                
                county.loc.forEach(function (location) {
                    if (location.searchName.indexOf(searchTerm) === 0) {
                        results.push({
                            id: location.id,
                            name: location.proper,
                            rang: location.rang,
                            seokey: location.seo_key,
                            isCounty: 0,
                            displayName: '<span class="e-location-name">' + location.proper + '</span>' +
                                '<span class="e-location-county">, județul ' + county.name + '</span>'
                        });
                    }
                });
            });
            
            results.sort(function (a, b) {
                if (!a.isCounty && b.isCounty) {
                    return 1;
                }
                
                if (a.isCounty && !b.isCounty) {
                    return -1;
                }
                
                if (a.rang > b.rang) {
                    return 1;
                }
                
                if (a.rang < b.rang) {
                    return -1;
                }
                
                return a.name > b.name;
            });
            
            var displayedResults = results.splice(0,7);
            
            $locationAutosuggest.html('');
            displayedResults.forEach(function (result) {
                $locationAutosuggest.append('<li class="b-suggestion" ' + 
                        'data-county="' + result.isCounty + 
                        '" data-id="' + result.id + 
                        '" data-name="' + result.name + 
                        '" data-seokey="' + result.seokey + '">' + 
                        result.displayName + 
                        '</li>');
            });
        });
        
        $('.e-location-autosuggest').on('click', 'li', function () {
            var $this = $(this);
            $('#searchmodel-auto').val($this.data('name'));
            if (parseInt($this.data('county'), 10) === 1) {
                $('.js-county-id').val($this.data('id'));
                $('.js-county-seo').val($this.data('seokey'));
                $('.js-city-id').val('');
                $('.js-city-seo').val('');
            } else {
                $('.js-city-id').val($this.data('id'));
                $('.js-city-seo').val($this.data('seokey'));
                $('.js-county-id').val('');
                $('.js-county-seo').val('');
            }
            $('.e-location-autosuggest').html('');
        });
        
        $(document).ready(function () {
            var self = OferaCRM.FE.Index;
            var E = self.elements;
            
            if (E.$search.length > 0) {
                E.$search.on('click', self.doSearch);
            }
            
            if (E.$term.length > 0) {
                E.$term.on('keyup', function (e) {
                    if (e.keyCode === 13) {
                        self.doSearch();
                    }
                });
            }
        });
    })(jQuery);
})();